import { ReactNode, useEffect } from 'react';

import { seoConfig, SeoData, AllRouteKeys } from '../../router/seoConfig';

type SeoWrapperProps = {
  pageKey: AllRouteKeys;
  children: ReactNode;
};

export const SeoWrapper = ({ pageKey, children }: SeoWrapperProps) => {
  useEffect(() => {
    const seo: SeoData | undefined = seoConfig[pageKey];

    if (seo) {
      if (seo.description) {
        updateMetaTag('description', seo.description);
      }
      if (seo.keywords) {
        updateMetaTag('keywords', seo.keywords.join(', '));
      }
    }

    const baseUrl = import.meta.env.VITE_API_FRONT_APP_URL || window.location.origin;
    const canonicalHref = seo?.canonical ? `${baseUrl}${seo.canonical}` : `${baseUrl}${window.location.pathname}`;

    updateCanonicalLink(canonicalHref);

    return () => removeCanonicalLink();
  }, [pageKey]);

  return <>{children}</>;
};

function updateMetaTag(name: string, content: string) {
  let meta = document.querySelector(`meta[name="${name}"]`);

  if (meta) {
    meta.setAttribute('content', content);
  } else {
    meta = document.createElement('meta');
    meta.setAttribute('name', name);
    meta.setAttribute('content', content);
    document.head.appendChild(meta);
  }
}

function updateCanonicalLink(href: string) {
  let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;

  if (link) {
    link.setAttribute('href', href);
  } else {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', href);
    document.head.appendChild(link);
  }
}

function removeCanonicalLink() {
  const link = document.querySelector('link[rel="canonical"]');

  if (link) {
    link.remove();
  }
}
